import React from 'react';
import { Col } from 'react-bootstrap';
import RichText from 'src/components/rich_text/RichText';
import CheckboxField from '../form_fields/CheckboxField';

const OptInSection: React.FC<{ optInLabel: string }> = ({ optInLabel }) => {
  return (
    <Col xs={12} className="!pds-mt-4">
      <CheckboxField label={<RichText body={optInLabel} />} name="optIn" required />
    </Col>
  );
};

export default OptInSection;
